import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { list, clear } from './actions';
import { SiteInfo } from '../../../models/SiteInfo';

export interface SiteInfoListSubdivState {
  loaded: boolean;
  items: SiteInfo[];
}

const initialState: SiteInfoListSubdivState = {
  loaded: false,
  items: []
};

const reducer = reducerWithInitialState(initialState)
  .case(list.started, (state) => {
    return { ...state, loaded: false };
  })
  .case(list.done, (state, param) => {
    const items: SiteInfo[] = param.result.Items;
    return { ...state, loaded: true, items};
  })
  .case(list.failed, (state, error) => {
    console.log('reducer async failed error', error);
    return { ...state };
  })
  .case(clear, (state, param) => {
    return { ...state, loaded: false, items: []};
  })
;

export default reducer;


// WEBPACK FOOTER //
// ./src/redux/modules/siteInfoListSubdiv/reducers.ts